<article class="report-view-container">
  <div class="" [innerHTML]="formattedData"></div>
</article>